module.exports = __webpack_public_path__ + "images/external_images/img/mockups/img7.png";